import { render, staticRenderFns } from "./BuyModal.vue?vue&type=template&id=54c3b9cc&scoped=true&"
import script from "./BuyModal.vue?vue&type=script&lang=js&"
export * from "./BuyModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyModal.vue?vue&type=style&index=0&id=54c3b9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3b9cc",
  null
  
)

export default component.exports